define([
    './googleAnalytics',
    './googleAnalyticsAdapterProvider',
    './SegmentIOAdapterProvider',
    './ConsoleLogAdapter',
    './LocalstorageAdapter'
], (googleAnalytics,
    googleAnalyticsAdapterProvider,
    segmentIOAdapterProvider,
    consoleLogAdapter,
    localStorageAdapter) => {
    angular.module('edge.platform.tracking.adapters', [])
        .factory('googleAnalytics', googleAnalytics)
        .provider('adapters.googleAnalytics', googleAnalyticsAdapterProvider)
        .provider('adapters.segmentIO', segmentIOAdapterProvider)
        .value('adapters.console', consoleLogAdapter)
        .value('adapters.localstorage', localStorageAdapter);
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/tracking/adapters/module.js